const isWeiXin = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  if (userAgent.indexOf('micromessenger') >= 0) {
    return true
  }
  return false
}
exports.isWeiXin = function() {
  return isWeiXin()
}



// WEBPACK FOOTER //
// ./src/common/isWeiXin.js